import QRCode from 'qrcode'

const _makeImage = (dataUrl) => {
    const image = new Image()
    image.src = dataUrl

    return new Promise(resolve => {
        image.onload = () => {
            resolve(image)
        }
    })
}

const LABEL_WIDTH = 812
const LABEL_HEIGHT = 1220
export default async (item = {}) => {
    const {barcodeNumber, name, address1, address2, city, country, state, postalCode} = item
    const addressCity = [city, `${state} ${postalCode}`].filter(i => !!i).join(', ')
    const address = [name, address1, address2, addressCity, country].filter(i => !!i)
    const barcode_number = `#${barcodeNumber}`
    const data = await QRCode.toDataURL(barcodeNumber.toString(), {
        errorCorrectionLevel: 'H',
        margin: 2,
        scale: 20,
        color: {
            dark: '#000000',
            light: '#FFFFFF'
        }
    })
    const qrImage = await _makeImage(data)

    const canvas = document.createElement('canvas')
    canvas.width = LABEL_WIDTH
    canvas.height = LABEL_HEIGHT
    const ctx = canvas.getContext('2d')

    ctx.fillStyle = 'white'
    ctx.fillRect(0, 0, LABEL_WIDTH, LABEL_HEIGHT)

    ctx.lineWidth = 4
    ctx.strokeStyle = '#000'
    ctx.strokeRect(10, 10, LABEL_WIDTH - 20, LABEL_HEIGHT - 20)

    const qrSize = 260
    const qrX = LABEL_WIDTH - qrSize - 60
    const qrY = 80
    ctx.drawImage(qrImage, qrX, qrY, qrSize, qrSize)

    ctx.font = 'bold 48px Arial'
    ctx.fillStyle = '#000'
    ctx.textAlign = 'left'
    ctx.fillText(barcode_number, 80, 120)

    //Draw address
    if (address.length > 0) {
        address.forEach((i, index) => {
            if (!!i) {
                ctx.fillStyle = 'black'
                ctx.font = '42px Arial'
                ctx.fillText(i, 80, (440 + (index * 80)))
            }
        })
    }

    /* VN big text bottom center */
    ctx.font = 'bold 220px Arial'
    ctx.textAlign = 'center'
    ctx.fillText(
        country,
        LABEL_WIDTH / 2,
        LABEL_HEIGHT - 180
    )

    return canvas.toDataURL()
}
